import React from "react";
import { Box, Flex, Heading, Text } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var BenefitBox = function BenefitBox(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      subtitle = _ref.subtitle;
  return ___EmotionJSX(Box, {
    width: "50%",
    p: "8px"
  }, ___EmotionJSX(Box, {
    borderRadius: "16px",
    borderColor: "onePass.primary",
    borderWidth: "1px",
    borderStyle: "solid",
    height: "160px",
    color: "onePass.textPrimary",
    px: "12px"
  }, ___EmotionJSX(Flex, {
    alignItems: "center",
    height: "52px",
    color: "onePass.primaryDark"
  }, icon), ___EmotionJSX(Heading.h4, {
    lineHeight: "normal",
    m: "0",
    mb: "4px",
    fontWeight: "bold",
    fontFamily: "inherit"
  }, title), ___EmotionJSX(Text, {
    fontWeight: "medium",
    m: "0",
    fontSize: "xs"
  }, subtitle)));
};